import { Map as ImMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';

import type { ConfirmationDialogProps } from './types';
import { DIALOG_TYPE as CONFIRMATION_DIALOG_TYPE, mkConfirmationDialogProps } from './types';

const showConfirmationDialog = (props: ConfirmationDialogProps) => {
  store?.dispatch(
    rootUiActions.createDialog(
      rootUiTypes.mkRootUiData({
        id: props.id || 'delete-project',
        type: CONFIRMATION_DIALOG_TYPE,
        props: ImMap(mkConfirmationDialogProps(props)),
      }),
    ),
  );
};
export default showConfirmationDialog;
